<template>
    <block-section class="section">
        <div class="container">
            <div class="identity">
                <router-link to="/">
                    <logo />
                </router-link>
            </div>

            <div v-if="testMode" class="testMode">
                Test 2.0 mode
            </div>
             <div v-else-if="stagingMode" class="testMode">
                Staging 2.0 mode
            </div>

            <div class="menu-toggle">
                <button
                    :class="{
                        'menu-toggle-button': true,
                        open: menuOpen
                    }"
                    aria-controls="navigation"
                    :aria-expanded="menuOpen ? 'true' : 'false'"
                    @click="menuOpen = !menuOpen"
                >
                    <span class="bars">
                        <span />
                        <span />
                        <span />
                        <span />
                    </span>
                    <span class="title">{{ $t("block_header.menu") }}</span>
                </button>
            </div>

            <div id="navigation" class="navigation">
                <div
                    :class="{
                        menus: true,
                        open: menuOpen,
                        'not-open': !menuOpen
                    }"
                >
                    <nav aria-label="main menu" class="main-menu-nav">
                        <ul class="main-menu">
                            <li
                                :class="{
                                    active: currentFlowType === zoneTicketType
                                }"
                            >
                                <router-link :to="paths.newZoneTicket">
                                    {{ $t("page_new_zone_ticket.title") }}
                                </router-link>
                            </li>
                            <li
                                :class="{
                                    active:
                                        currentFlowType === retireeTicketType
                                }"
                            >
                                <router-link :to="paths.retireeProducts">
                                    {{ $t("page_retiree_products.title") }}
                                </router-link>
                            </li>
                            <li
                                :class="{
                                    active:
                                        currentFlowType === fixedPriceTicketType
                                }"
                            >
                                <router-link :to="paths.fixedPriceProducts">
                                    {{
                                        $t("page_new_fixed_price_ticket.title")
                                    }}
                                </router-link>
                            </li>
                            <!-- <li
                                :class="{
                                    active:
                                        currentFlowType === controlFeeType
                                }"
                            >
                                <router-link :to="paths.controlfee">
                                    {{
                                        $t("page_controlfee.title") 
                                    }}
                                </router-link>
                            </li> -->
                        </ul>
                    </nav>

                    <nav aria-label="secondary menu" class="secondary-menu-nav">
                        <ul class="secondary-menu">
                            <li>
                                <a
                                    href="https://www.midttrafik.dk/"
                                    target="_blank"
                                >{{ $t("block_header.to_main_page") }}</a>
                            </li>
                            <li>
                                <a
                                    href="https://www.midttrafik.dk/kundeservice/privatlivspolitik/"
                                    target="_blank"
                                >{{ $t("block_header.privacy_policy") }}</a>
                            </li>
                            <li>
                                <selector-locale />
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    </block-section>
</template>

<script>
import paths from "@/router/paths";

import {
    FLOW_TYPE_ZONE_TICKET,
    FLOW_TYPE_RETIREE_TICKET,
    FLOW_TYPE_FIXED_PRICE_TICKET,
    FLOW_TYPE_CONTROLFEE
} from "@/store/modules/flow";

const SelectorLocale = () => ({
    component: import(
        /* webpackMode: "eager", webpackChunkName: "selector-locale" */ process
            .env.VUE_APP_LOCALESELECTOR_TYPE === "FlagLocaleSelector"
            ? "@/components/selectors/SelectorLocaleFlag"
            : "@/components/selectors/SelectorLocaleText"
    )
});

export default {
    components: {
        SelectorLocale
    },
    data() {
        return {
            menuOpen: false,
            testMode: process.env.VUE_APP_SERVER !== "live" && process.env.VUE_APP_SERVER !== "staging",
            stagingMode: process.env.VUE_APP_SERVER === "staging"
        };
    },
    computed: {
        paths: () => paths,
        zoneTicketType: () => FLOW_TYPE_ZONE_TICKET,
        retireeTicketType: () => FLOW_TYPE_RETIREE_TICKET,
        fixedPriceTicketType: () => FLOW_TYPE_FIXED_PRICE_TICKET,
        controlFeeType: () => FLOW_TYPE_CONTROLFEE,
        currentFlowType() {
            let cur = this.$route.meta && this.$route.meta.flowType;
            if (!cur) cur = this.$store.getters["flow/getType"];
            return cur;
        }
    },
    watch: {
        $route() {
            this.menuOpen = false;
        }
    }
};
</script>

<style scoped lang="scss">
.testMode {
    color: red;
    font-size: 1rem;
    font-weight: 600;
    text-align: center;
    width: 110px;
    position: fixed;
    top: 20px;
    right: 60px;
    z-index: 1000;
}

.section {
    padding: 0;
    background: white;
    box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.2);
}

.container {
    position: relative;
    z-index: 10;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
}

.identity {
    padding: 0.5rem 3rem 0.5rem 1rem;
    flex: 1 1 180px;
    background: white;
}

.identity img {
    height: 50px;
}

.navigation {
    position: relative;
    width: 100%;
    order: 3;
}

.menu-toggle {
    padding: 0 1rem;
}

.menu-toggle-button {
    background: none;
    border: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 2px;
    cursor: pointer;
}

.menu-toggle-button .title {
    font-size: 12px;
    color: $color-dark-grey;
}

.menu-toggle-button ::v-deep .bars {
    width: 20px;
    height: 14px;
    position: relative;
    transform: rotate(0deg);
    transition: 0.3s ease-in-out;
    margin: 4px;
}

.menu-toggle-button ::v-deep .bars span {
    display: block;
    position: absolute;
    height: 2px;
    width: 100%;
    background: #000;
    opacity: 1;
    left: 0;
    transform: rotate(0deg);
    transition: 0.25s ease-in-out;
}

.menu-toggle-button ::v-deep .bars span:nth-child(1) {
    top: 0;
}

.menu-toggle-button ::v-deep .bars span:nth-child(2),
.menu-toggle-button ::v-deep .bars span:nth-child(3) {
    top: 6px;
}

.menu-toggle-button ::v-deep .bars span:nth-child(4) {
    top: 12px;
}

.menu-toggle-button.open ::v-deep .bars span:nth-child(1) {
    top: 6px;
    width: 0%;
    left: 50%;
}

.menu-toggle-button.open ::v-deep .bars span:nth-child(2) {
    transform: rotate(45deg);
}

.menu-toggle-button.open ::v-deep .bars span:nth-child(3) {
    transform: rotate(-45deg);
}

.menu-toggle-button.open ::v-deep .bars span:nth-child(4) {
    top: 6px;
    width: 0%;
    left: 50%;
}

.menus {
    position: absolute;
    background: white;
    top: 0;
    width: 100%;
    transform: translate3d(0, -100%, 0);
    z-index: -1;
    transition: transform 0.3s;
}

.menus.open {
    transform: translate3d(0, 0, 0);
    box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.2);
    visibility: visible;
}

.menus.not-open {
    visibility: hidden;
}

.main-menu,
.secondary-menu {
    list-style-type: none;
    padding: 0;
    margin: 0;
}

.main-menu a {
    text-transform: uppercase;
    color: $color-darkest-grey;
    font-weight: 400;
    text-decoration: none;
    font-size: 1rem;
}

.main-menu {
    margin-top: 1rem;
}

.main-menu li {
    padding: 1rem;
}

.secondary-menu {
    margin-top: 2rem;
    margin-bottom: 2rem;
    color: $color-medium-grey;
}

.secondary-menu a {
    text-decoration: none;
    color: $color-medium-grey;
    line-height: 24px;
}

.secondary-menu li {
    padding: 0.5rem 1rem;
}

.secondary-menu li:last-child {
    padding-right: 0;
}

@media (min-width: $breakpoint-tablet) {
    .testMode {
        width: 200px;
        top: 10px;
        right: calc(50% - 100px);
        font-size: 1.5rem;
    }

    .section {
        padding-left: 1.5rem;
        padding-right: 1.5rem;
    }

    .identity {
        flex: 0 0 180px;
        padding-left: 0;
    }

    .identity img {
        height: auto;
    }

    .navigation {
        order: initial;
        width: auto;
        flex: 1 1 0px;
        padding-left: 1rem;
    }

    .menus {
        position: static;
        transform: none;
        transition: none;
        display: flex;
        flex-direction: column-reverse;
        justify-content: space-between;
        box-shadow: unset !important;
        visibility: visible !important;
    }

    .menu-toggle {
        display: none;
    }

    .main-menu,
    .secondary-menu {
        display: flex;
        margin: 0;
    }

    .main-menu a {
        color: $color-dark-grey;
        display: block;
        padding: 1rem 1.5rem;
    }

    .main-menu li {
        padding: 0;
        transition: background-color 0.2s;
        margin-right: 4px;
    }

    .main-menu li.active,
    .main-menu li:hover {
        background: $color-primary;
    }

    .main-menu li.active a,
    .main-menu li:hover a {
        color: white;
    }

    .secondary-menu-nav {
        align-self: flex-end;
        margin-top: 1rem;
    }
}
</style>
